import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import AdminPage from './AdminPage';
import MaskedInput from '../components/MaskedInput';
import ErrorComponent from '../components/ErrorComponent';
import { Checkbox } from 'react-bootstrap';

export default class AdminAttributesPage extends PageComponent {

  static PageInfo = {
    parent: AdminPage,
    path: "/Admin/Attributes",
    name: "menu.attributes",
    permission: { "CONFIGURATION_TREATMENT_LIST": true },
    access: { 1: true },
    icon: "cubes"
  }

  constructor(props) {
    super(props);
    this.state.loading = true;
    this.state.isModalVisible = false;
    this.state.modalError = null;
    this.state.modalLoading = false;
    this.state.inputText = null;
    this.state.description = null;
    this.state.error = null;
    this.state.isChecked = false;
    };




  componentDidMount() {

    Connection.Secure(Connection.service + 'Attribute/Menu')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  addUser() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Attribute",
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({ label: this.state.inputText, description: this.state.description })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            try {
              this.state.data.push(data);
            } catch (e) { }
            this.setState({ isModalVisible: false, data: this.state.data, modalLoading: false });
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }


  deleteItem() {
    var item = this.state.selectedItem;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + 'Attribute/' + item.keyConstant,
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          try {
            this.state.data.splice(this.state.data.indexOf(item), 1);
          } catch (e) { }
          this.setState({ modalLoading: false, isModalVisible: false, data: this.state.data });
        } else
          this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }



  activateItem() {
    var item = this.state.selectedItem;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Attribute",
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({ active: this.state.isChecked ? 1 : 0, keyConstant: item.keyConstant})
      })
      .then((response) => {
          if (response.ok && response.status == 200){
            response.json().then((data) => {
              window.location.reload(false);
              this.setState({ isModalVisible: false, modalLoading: false});
          });
        }else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }




  render() {
    return (
      <Container context={this.constructor}>


        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  {this.state.data
                    && this.state.data.length > 0 ? this.state.data.map((item) =>
                      <div className="generics_listing_item" >
                        <FontAwesomeIcon icon="cube" className="generics_listing_item_icon" />
                        <div className="generics_listing_content" >
                          <div className="generics_listing_item_title" >{Parsers.parseUpperCase(item.label)}</div>
                          <div className="generics_listing_item_description" >{item.description}</div>
                        </div>

                      
                        <label className="switch">
                          <input type="checkbox" checked={item.active} onChange={(e) => {this.setState({ isChecked: !item.active, isModalVisible: "activate", selectedItem: item }); return GenericHelper.cancelBubble(e);}}/>
                          <div className="slider"></div>
                        </label>
                        
                        <div className="generics_listing_item_action" onClick={(e) => { this.setState({ isModalVisible: "delete", selectedItem: item }); return GenericHelper.cancelBubble(e); }}><FontAwesomeIcon icon="times" /></div>
                      </div>
                    )
                    : null}
                </div>
          }

<Modal
            className={this.state.modalLoading == true ? "modal-loading" : ""}
            onHide={() => { }} show={this.state.isModalVisible}
          // onHide={handleClose}
          >
            <div>
              {
                this.state.modalInitializing != false ? 
                <div>
                  {Labels.GetLabel("adminuserpage.saving")}
                </div> 
                :
                  this.state.isModalVisible == "delete" ?
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel("generic.delete")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {Labels.GetLabel("generic.confirmdel")}
                        <br />
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                          {Labels.GetLabel("adminstategroup.closebtn")}
                        </Button>
                        <Button variant="primary" onClick={() => this.deleteItem()}>
                          {Labels.GetLabel("generic.confirm")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
                    :
                    this.state.isModalVisible == "activate" ?
                      <div>
                        <Modal.Header>
                          <Modal.Title>{Labels.GetLabel("generic.activate")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {Labels.GetLabel("generic.confirmactivate")}
                          <br />
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                            {Labels.GetLabel("adminstategroup.closebtn")}
                          </Button>
                          <Button variant="primary" onClick={() => this.activateItem()}>
                            {Labels.GetLabel("generic.confirm")}
                          </Button>
                        </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                      </div>
                    :
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel("brand.Attribute")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <MaskedInput type="text" label={Labels.GetLabel("generic.value")} notnull={true} onValid={(value) => this.setState({ inputText: value })}
                          onInvalid={(value) => this.setState({ inputText: null })} />
                        <MaskedInput type="text" label={Labels.GetLabel("generic.description")} notnull={true} onValid={(value) => this.setState({ description: value })}
                          onInvalid={(value) => this.setState({ description: null })} />
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                          {Labels.GetLabel("adminuserpage.closebtn")}
                        </Button>
                        <Button variant="primary" disabled={this.state.inputText == null || this.state.description == null} onClick={() => this.addUser()}>
                          {Labels.GetLabel("adminuserpage.savebtn")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
              }
            </div>
          </Modal>
          

          <div className="generics_floatinbtn" onClick={() => this.setState({ isModalVisible: true, inputText: "" })}>
            <FontAwesomeIcon className="generics_floatinbtn_icon" icon="plus" />
          </div>
        </div>
      </Container >
    );
  }
}